module.exports = __webpack_public_path__ + "media/images/application/template/ancon-logo-89910e98282292f76f3993ffc0c7f139.svg";